import type { Role } from './api';

/**
 * Mirrors apps/api/src/auth/roles.ts. The same trap applies on this side: a
 * literal `role === 'ADMIN'` silently hides things from the person with the
 * most authority, and it hides them quietly.
 */
const RANK: Record<Role, number> = {
  PENDING: 0,
  REQUESTER: 0,
  APPROVER: 0,
  ADMIN: 1,
  SUPER_ADMIN: 2,
  SYSTEM_ADMIN: 3,
  MTN_TECHNICIAN: 0,
  APPROVED_VIEWER: 0,
};

export const isAdmin = (role: Role): boolean => RANK[role] >= RANK.ADMIN;
export const isSuperAdmin = (role: Role): boolean => RANK[role] >= RANK.SUPER_ADMIN;
export const isApprover = (role: Role): boolean => role === 'APPROVER' || isAdmin(role);
export const isSystemAdmin = (role: Role): boolean => role === 'SYSTEM_ADMIN';
/** May see and work the IT queue: every administrative tier, plus MTN_TECHNICIAN. */
export const canWorkItQueue = (role: Role): boolean => isAdmin(role) || role === 'MTN_TECHNICIAN';
/** Reads approved requests and does nothing else. Nobody else "is also" a viewer. */
export const isApprovedViewer = (role: Role): boolean => role === 'APPROVED_VIEWER';
